<template>
  <div class="wrap">
    <component :is="comp" :relate-id="relateId" :raw-relate-id="rawRelateId" :form-id="relateId" :form-code="form.formCode" :options="options"> </component>
  </div>
</template>

<script>
import tableRenderVue from "./components/tableRender.vue";
import customPageRender from "./components/customPageRender.vue";
import VFormRender from "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue";

import { getListConfigJSONByFormCode } from "@/CommonDP/service/listFlow-service";

export default {
  data() {
    return {
      comp: "",
      relateId: "",
      rawRelateId: "",
      form: {
        formId: "",
        formCode: ""
      },
      isRouter: false,
      options: {},
      meta: null,
      isLeave: false
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        const { matched } = this.$route;
        matched.some((item, index) => {
          if (item.instances.default === this) {
            const prev = matched[index - 1] || {};
            console.log("commonRender watch $route", item.meta, this._uid, prev);
            // 获取前一个matched，如果前一个matched的meta满足以下条件，则代表上一个matched也是动态路由，如果再满足isLeave为true，则代表此组件实例为被销毁前的状态，不需要重写请求数据
            if (!(prev?.meta?.relateId && prev?.meta?.type && this.isLeave)) {
              console.log("commonRender watch $route exec", item.meta, this._uid);
              this.init(item.meta);
            }
            return true;
          }
        });
      },
      deep: true,
      immediate: true
    }
  },

  // beforeCreate() {
  //   console.log("commonRender beforeCreate");
  // },

  // created() {
  //   console.log("commonRender created", this._uid);
  // },

  // async mounted() {
  //   console.log("commonRender mounted", this._uid);
  // },

  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      vm.isLeave = true;
      console.log("commonRender beforeRouteEnter", vm._uid);
    });
  },

  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.isLeave = true;
    console.log("commonRender beforeRouteLeave", this._uid);
    next();
  },

  methods: {
    async init(meta) {
      const renderMap = {
        list: tableRenderVue,
        form: VFormRender,
        customPage: customPageRender
      };
      this.meta = meta;
      const { type, relateId: rawRelateId } = this.meta || this.$route.meta;
      const randomNumber = rawRelateId.split("__").at(-1);
      var reg = new RegExp(`__${randomNumber}`);
      const relateId = rawRelateId.replace(reg, "");
      this.form.formCode = relateId;
      if (relateId) {
        const res = await getListConfigJSONByFormCode(relateId);
        console.log(res, "commonRender res");
        const {
          data: { formId, json }
        } = res;
        this.options = JSON.parse(json);
        this.relateId = formId;
        this.rawRelateId = rawRelateId;
        await this.$nextTick();
        this.comp = renderMap[type || "list"];
      } else {
        console.warn("当前页面没有关联配置项！");
      }
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrap {
  height: 100%
}
</style>
